angular.module('festzelt-os.components')
    .directive('modalDraggable', [
        '$document',
        function ($document) {
            return function (scope, element) {
                let startX = 0,
                    startY = 0,
                    x = 0,
                    y = 0,
                    elementHeader = angular.element(document.getElementsByClassName("modal-header"));

                element = angular.element(document.getElementsByClassName("modal-content"));
                elementHeader.css({
                    cursor: 'move'
                });

                elementHeader.on('mousedown', function (event) {
                    // Prevent default dragging of selected content
                    event.preventDefault();
                    startX = event.screenX - x;
                    startY = event.screenY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                function mousemove(event) {
                    y = event.screenY - startY;
                    x = event.screenX - startX;
                    element.css({
                        top: y + 'px',
                        left: x + 'px'
                    });
                }

                function mouseup() {
                    $document.unbind('mousemove', mousemove);
                    $document.unbind('mouseup', mouseup);
                }
            };
        }]);



// WEBPACK FOOTER //
// ./src/app/components/directives/modal-draggable/modal-draggable-directive.js